/** A mounted editor may cancel explicit portal navigation before state is lost. */
export const PORTAL_NAVIGATION_REQUEST = 'rebels:portal-navigation-request';
export const requestPortalNavigation = () => window.dispatchEvent(new Event(PORTAL_NAVIGATION_REQUEST, { cancelable: true }));
